import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { PublicSharedModule } from '../../../public-shared/public-shared.module';
import { EventsBrowseComponent } from './events-page.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime-ex';
import { NgSelectModule } from '@ng-select/ng-select';

const browseRoutes: Routes = [{ path: '', component: EventsBrowseComponent }];

@NgModule({
  declarations: [EventsBrowseComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(browseRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    PublicSharedModule,
    PaginationModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule ,
    NgSelectModule
  ],
})
export class BrowseModule {}
